import React, { useEffect, useState } from "react";
import "./Login.css";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import axiosInstance from "../../axiosinterceptor";
import { useAuth } from "../../authContext/AuthContext";
// import { authenticate } from "../../authContext/CognitoAuth"; 
import { BiLoader, BiShow, BiHide } from "react-icons/bi";
import ForgotPassword from "../forgotpassword/ForgotPassword";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { configData } from "../Navbar/config";
import { clearCodebookFromIndexedDB } from "../../utils/indexedDB";


function Login({ setShowLogin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  // console.log(params, "params");
  const hcpLineID = params.get("hcp_line_id");
  // console.log(hcpLineID, "hcpLineID");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showLoginPage, setShowLoginPage] = useState(true);
  const { setIsAuthenticated, setUserEmail, setPermissions } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  //  useEffect(() => {
  //     const storedAccessToken = sessionStorage.getItem("accessToken");
  //     if (storedAccessToken) {
  //       console.log(storedAccessToken, storedAccessToken)
  //       // optional: restore hcpLineID from localStorage if needed
  //       // const storedHcp = localStorage.getItem("episodeHcpLineId");
  //      if(hcpLineID) {
  //         localStorage.setItem('last_hcp_line_id', hcpLineID)
  //         localStorage.setItem('episodeHcpLineId',hcpLineID)
  //         navigate("/coder");
  //       } else {
  //         navigate("/");
  //       }
  //     }
  //   }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(""); // Reset error before attempting login
    // console.log("first=============")
    clearCodebookFromIndexedDB();
    localStorage.removeItem("isFetched12");
    localStorage.removeItem("isFetched13");

    const payload = {
      username: username,
      password: password,
    };

    try {
      const response = await axiosInstance.post("/admin_login_users_acs", payload);
      setLoading(false);

      if (response.data.statusCode !== 400) {
        // console.log(response.data.body, "%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%")

        const { accessToken, refreshToken, message, permissions, user_email, user_id, organization_id, country_id } = response.data.body; // No need to parse
        //console.log('checkrepsonse',response.data.body,organization_id,country_id);
        // Show success message
        toast.success(message);

        // Store tokens and user info in session storage
        sessionStorage.setItem("loginSession", accessToken);
        sessionStorage.setItem("accessToken", accessToken);
        sessionStorage.setItem("refreshToken", refreshToken);
        sessionStorage.setItem("useremail", user_email); // Save email from response
        sessionStorage.setItem("userId", user_id); // Save email from response
        setUserEmail(user_email); // Set email in AuthContext
        sessionStorage.setItem("organizationId", organization_id);
        sessionStorage.setItem("countryId", country_id);
        // console.log(user_id,"***************************!!!!!!!!!!!!!!!!!");
        // Store theme preference in session storage
        sessionStorage.setItem("mode", "DARK"); // Set theme mode

        // Store permissions if available
        if (permissions) {
          sessionStorage.setItem("permissions", JSON.stringify(permissions)); // Store permissions in session storage
          setPermissions(permissions); // Update permissions in context
        }
        // console.log(hcpLineID, "hcpLineID", process.env.REACT_APP_FLAG_USA);
        if (process.env.REACT_APP_FLAG_USA === "usa" && hcpLineID) {
          localStorage.setItem("last_hcp_line_id", hcpLineID);
          localStorage.setItem("episodeHcpLineId", hcpLineID);
          localStorage.setItem("currentPage", "episodeList");
          // localStorage.setItem("enableHCPQueryParamsFunctionality", true);
          navigate("/coder");
        } else {
          // localStorage.setItem("enableHCPQueryParamsFunctionality", false);
          navigate("/");
        }

        // Update sessionStorage storage and state
        sessionStorage.setItem("isAuthenticated", "true");
        setIsAuthenticated(true);
      } else {
        toast.error(JSON.parse(response.data.body || "login failed"));
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      toast.error("Login failed, please try again.");
    }
  };
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);
  return (
    <>
      {showLoginPage ? (
        <div className="login-container-usa">
          <ToastContainer autoClose={20000} />
          <form className="login-form" onSubmit={handleSubmit}>
            <h2 className="login-header">Login</h2>
            <div className="input-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setError("");
                }}
                disabled={loading}
              />
            </div>
            <div
              className="input-group"
              style={{
                display: "flex",
                alignItems: "center",
                position: "relative",
              }}
            >
              <label htmlFor="password">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                disabled={loading}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  cursor: "pointer",
                  color: "#888",
                  top: "50%",
                }}
              >
                {showPassword ? <BiHide /> : <BiShow />}
              </span>
            </div>
            <button
              className="Login-btn btn btn-warning"
              type="submit"
              disabled={loading}
            >
              {loading && !error ? <BiLoader /> : "Log In"}
            </button>
            {error && <p className="login-errorMessage">{error}</p>}
            <div>
              <p className="switchSignUp">
                Don't have an account?{" "}
                <span onClick={() => setShowLogin(true)}> Sign Up</span>
              </p>
              <p
                className="forgotPassword"
                onClick={() => {
                  setShowLoginPage(false);
                }}
              >
                Forgot Password?
              </p>
            </div>
          </form>
        </div>
      ) : (
        <ForgotPassword setShowLoginPage={setShowLoginPage} />
      )}
    </>
  );
}

export default Login;
